import type {ExtractArgs} from '@iiiristram/ts-type-utils'
import { Fetch, ServerError } from '@logistics-frontend/core/utils/network';
import type {Error} from '@logistics-frontend/types/schemas/cardstorage/api'

const CORP_CLIENT_SERVICE_ADDRESS = 'account2'
const ERROR_CODE = 403
const ERROR_REASON = 'no_secured_phone'

const isForbiddenError = (status: number) => status === ERROR_CODE

const isNoSecuredPhoneError = (body: Error) => body.code === ERROR_REASON

const isCorpClientCabinet = () => window.location.pathname.includes(CORP_CLIENT_SERVICE_ADDRESS)

const redirectToPassport = () => {
  const redirectHost = new URL('phoneconfirm', window.__CORP_CLIENT?.config.passportHost)
  window.location.href = `${redirectHost}?retpath=${window.location.href}`
}

const onCatch = (error: ServerError) => {
  if (isForbiddenError(error.status) && isNoSecuredPhoneError(error.body) && isCorpClientCabinet()) {
    return redirectToPassport() as never
  } else {
    throw error
  }
}

export const withPassportRedirect = <TRequestBody = unknown, TResponseBody = unknown, TTransformedBody = unknown>(
  fetch: Fetch<TRequestBody, TResponseBody, TTransformedBody>,
) => {
  return (...[config]: ExtractArgs<typeof fetch>) => {
    return fetch(config).catch(onCatch)
  }
}
